import moment from 'moment'
riot.tag2('payments-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Новый платёж</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-12">\n            <h4>Информация о заказе</h4>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Заказ</label>\n                  <div class="input-group">\n                    <input class="form-control" value="{item.idOrder ? &quot;Заказ № &quot; + item.idOrder + &quot; от &quot; + order.dateOrder + &quot; [&quot; + order.customer + &quot;]&quot; : &quot;&quot;}" __readonly="{true}">\n                    <div class="input-group-btn">\n                      <div class="btn btn-default" onclick="{selectOrder}"><i class="fa fa-list text-primary"></i></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="row" if="{item.idOrder}">\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Сумма заказа</label>\n                  <input class="form-control" value="{order.amount}" __readonly="{true}">\n                </div>\n              </div>\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Оплачено</label>\n                  <input class="form-control" value="{order.paid}" __readonly="{true}">\n                </div>\n              </div>\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Доплата</label>\n                  <input class="form-control" value="{order.surcharge % 1 == 0 ? Number(order.surcharge) : order.surcharge}" __readonly="{true}">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <h4>Информация о платеже</h4>\n            <div class="row">\n              <div class="col-md-6">\n                <div class="form-group">\n                  <label class="control-label">Дата платежа</label>\n                  <datetime-picker class="form-control" name="date" format="DD.MM.YYYY HH:mm" value="{item.dateDisplay}"></datetime-picker>\n                </div>\n              </div>\n              <div class="col-md-6">\n                <div class="form-group {has-error: error.amount}">\n                  <label class="control-label">Сумма оплаты*</label>\n                  <input class="form-control" name="amount" min="0" step="1" value="{item.amount % 1 == 0 ? Number(item.amount) : item.amount}" type="{\'number\'}">\n                  <div class="help-block">{error.amount}</div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-8">\n                <div class="form-group">\n                  <label class="control-label">Тип оплаты</label>\n                  <select class="form-control" name="paymentType" value="{item.paymentType}">\n                    <option each="{paySystems}" value="{id}" __selected="{id == item.paymentType}" no-reorder>{name}</option>\n                  </select>\n                </div>\n              </div>\n              <div class="col-md-4" if="{item.paymentType == 0}">\n                <div class="form-group">\n                  <label class="control-label">Сумма на лицевом счёте</label>\n                  <input class="form-control" value="{item.contact.balance}" __readonly="{true}">\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Примечание</label>\n                  <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Добавить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

function loadPaySystems(modal) {
    var params = {};
    modal.paySystems = [];
    API.request({
        object: 'PaySystem',
        method: 'Fetch',
        data: params,
        success: function success(response, xhr) {
            modal.paySystems.push({ id: 0, name: "С лицевого счёта" });
            modal.paySystems = modal.paySystems.concat(response.items);
            modal.item.paymentTypeNames = modal.paySystems;
            modal.update();
        }
    });
}

self.reload = function () {
    //observable.trigger('payments-new')
};

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = {};
    modal.order = {};
    modal.paySystems = [];
    modal.error = false;

    modal.item.paymentTarget = opts.order.inpayee == "Y" ? 1 : 0;
    modal.item.idOrder = opts.order.id;
    modal.item.idAuthor = opts.order.idAuthor;
    modal.item.idCompany = opts.order.idCompany;
    modal.item.num = 1;
    modal.item.note = '';
    modal.item.date = moment().format('YYYY-MM-DD HH:mm:ss');
    modal.item.dateDisplay = moment().format('DD.MM.YYYY HH:mm');
    modal.item.year = moment().format('YYYY');
    modal.item.paymentType = 1;
    modal.item.idManager = app.config.idManager;
    modal.item.amount = opts.order.surcharge;
    modal.item.curr = opts.order.curr;

    modal.order.paid = opts.order.paid;
    modal.order.amount = opts.order.amount;
    modal.order.surcharge = opts.order.surcharge;
    modal.order.dateOrder = opts.order.dateOrder;
    modal.order.customer = opts.order.customer;

    modal.mixin('validation');
    modal.mixin('permissions');
    modal.mixin('change');

    modal.rules = function () {
        var rules = {
            amount: ['empty', 'number']
        };
        modal.item.amount = parseFloat(modal.item.amount);
        if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
    };

    loadPaySystems(modal);
    //modal.update

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules(), name));
    };

    modal.checkForSave = function () {
        if (modal.item.amount <= 0) {
            popups.create({
                title: 'Сохранение платежа!',
                text: 'Не указана сумма оплаты!',
                style: 'popup-danger'
            });
            return false;
        }

        if (modal.item.paymentType == 0 && modal.item.amount > modal.item.contact.balance) {
            popups.create({
                title: 'Сохранение платежа!',
                text: 'Сумма платежа превышает сумму на лицевом счете плательщика!',
                style: 'popup-danger'
            });
            return false;
        }
        return true;
    };

    modal.submit = function (e) {
        var params = modal.item;
        if (!modal.checkForSave()) return;
        modal.error = modal.validation.validate(modal.item, modal.rules());
        if (!modal.error) {
            return true;
        }
    };
});
});


// WEBPACK FOOTER //
// ./pages/payments/payments-add-modal.tag